import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { usePreferences } from '../contexts/PreferencesContext';
import { createAppTheme } from '../config/muiTheme';

/**
 * Wrapper component that provides MUI theme based on user preferences
 */
export const ThemeProvider = ({ children }) => {
  const { isDarkMode } = usePreferences();

  const theme = useMemo(() => createAppTheme(isDarkMode), [isDarkMode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};









